import { DefaultApi, Configuration } from "./generated";
import type { ConfigurationParameters } from "./generated";

export function getApi(parameters: ConfigurationParameters) {
    const apiConfiguration = new Configuration(parameters);

    return new DefaultApi(apiConfiguration);
}

export {    
    ConfigurationParameters as WeftParameters,
    DefaultApi as WeftApi,
};

export type {
    ResponseContext,
    Middleware
} from './generated';